import { WidthArchiveLabel } from '@app/shared/components';

import type { BaseOptionType } from 'antd/es/select';

export const getSelectOptionsWithDeletedItems = (
  data?: BaseOptionType[] | null
) => {
  if (!data?.length) return [];

  return data
    .sort((a, b) => {
      if (a.value === 0) return -1;
      if (b.value === 0) return 1;

      const isADeleted = a.IsDeleted || false;
      const isBDeleted = b.IsDeleted || false;

      if (isADeleted !== isBDeleted) {
        return isADeleted ? 1 : -1;
      }
      return a?.label?.localeCompare(b?.label ?? '') || 0;
    })
    .map(({ label, filterName, IsDeleted, value }) => ({
      label: <WidthArchiveLabel title={label} isDeleted={IsDeleted} />,
      value: value,
      filterName: filterName,
    }));
};
